// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.identification-page .not-in-time td.review-status,\n.identification-page .not-in-time .review-status .tr-value {\n  font-style: italic;\n  color: red;\n}\n.identification-page .not-checked td.review-status,\n.identification-page .not-checked .review-status .tr-value {\n  font-weight: 700;\n}\n", ""]);
// Exports
module.exports = exports;
